import React from "react";
import Icon from "../Icon";
import ContractIcon from "../../assets/images/icon/contract/contract-doc-icon.svg";
import EditButton from "../../assets/images/icon/edit-btn.svg";
import DeleteIcon from "../../assets/images/icon/delete-icon.svg";
import IconButton from "../Button/IconButton";
const ContractIssueList = ({
  setSelected,
  contractIssueList,
  setIsAddFormOpen,
  customDelete,
  customEdit,
  ...props }) => {


  const handleOnSelect = (e) => {
    setSelected(contractIssueList[e.target.value]);
  };

  return (
    <div className="contract-task-container">
      {contractIssueList
        .map((contract, idx) => {
          return (
            <React.Fragment key={idx}>
              <input
                id={`contract-task-${idx}`}
                name="contract-task-radio"
                className="contract-radio"
                type="radio"
                value={idx}
                onChange={handleOnSelect}
              />
              <label htmlFor={`contract-task-${idx}`} className="contract-list-box">
                <div className="contract-icon-wrap">
                  <Icon src={contract.icon} />
                </div>
                <div className="contract-name-wrap">
                  <p className="contract-name">{contract.label}</p>
                  {contract.description && (
                    <p className="contract-description">{contract.description}</p>
                  )}
                </div>
                {/* 수정, 삭제버튼 추가 */}
                {contract.type === "customContract" && (
                  <div className="contract-btn-wrap">
                    <IconButton
                      icon={EditButton}
                      action={() => customEdit(contract)}
                    />
                    <IconButton
                      icon={DeleteIcon}
                      action={() => customDelete(contract)}
                    />


                  </div>
                )}
              </label>
            </React.Fragment>
          );
        })}

      <>
        <input
          id="contract-add-button"
          className="contract-radio"
          type="button"
          onClick={() => {
            setIsAddFormOpen(true);
          }}
        />
        <label htmlFor="contract-add-button" className="contract-list-box add-btn">
          <div className="contract-icon-wrap">
            <Icon src={ContractIcon} />
          </div>
          <div className="contract-name-wrap">
            <p className="contract-name">새 계약서</p>
            <p className="contract-description">계약서 양식 등록</p>
          </div>
        </label>
      </>
    </div>
  );
};


export default ContractIssueList;
